import React from "react";
import "./tablerox.css";

/**
 * Marco del tablero: aplica el kit, resuelve los estados (cargando, error,
 * vacío) y deja un pie con la nota de alcance o el botón de limpiar filtros.
 * Un tablero nunca lista filas: sus hijos son KPIs, donas, barras y
 * tendencias cuyos números abren el tracking.
 * @author Diego Serrano <diego.serrano@repremundo.com.co>
 * @since 2026-09-14
 * @param {boolean} cargando  Muestra "Cargando…"
 * @param {string} error      Texto del error (ninguno = vacío)
 * @param {string} vacio      Texto cuando no hay nada que mostrar (ninguno = vacío)
 * @param {ReactNode} filtros Fila de filtros del tablero (opcional)
 * @param {string} pie        Nota pequeña al pie (alcance, fuente, corte)
 * @param {ReactNode} acciones Botones al pie (opcional)
 */
const Marcoxxx = ({ cargando = false, error = "", vacio = "", filtros = null, pie = "", acciones = null, children }) => (
  <div className="tbl">
    {filtros && <div className="tbl-card tbl-filtros">{filtros}</div>}
    {cargando && <span className="tbl-estado">Cargando el tablero...</span>}
    {!cargando && error && <span className="tbl-estado error">{error}</span>}
    {!cargando && !error && vacio && <span className="tbl-estado ok">{vacio}</span>}
    {!cargando && !error && !vacio && children}
    {(pie || acciones) && (
      <div className="tbl-pie">
        <span>{pie}</span>
        {acciones}
      </div>
    )}
  </div>
);

export default Marcoxxx;
